import Debug from 'debug';
const debug = Debug('model:actions:starve');

const notification = () => `starvation has set in`;

const attempt = ({ party }) => {
  const startingHealth = party.resources.attribs.health.value;
  const starvationPenalty = party.caravan.starvation();

  const result = {
    success: startingHealth > starvationPenalty,
    cost: {
      health: Math.min(startingHealth, starvationPenalty)
    }
  };

  debug(result);
  return result;
};

const executeSideEffects = (context, result) => {
  const { party } = context;
  const { cost } = result;
  const { history, resources } = party;

  // Track action
  history.add({ action: 'starve', result });

  // Update resources
  resources.delta({ health: -cost.health }, context);

  return {
    notification: notification(result)
  };
};

const action = {
  title: '',
  enabled: () => true,
  execute: context => {
    const result = attempt(context);
    const { notification } = executeSideEffects(context, result);

    return { success: result.success, notification };
  }
};

export default action;
